function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.7812 9.25C17.5312 8.8125 17.0625 8.53125 16.5625 8.53125H13.5938L14.5 5.8125C14.625 5.375 14.5312 4.9375 14.25 4.5625C13.9688 4.21875 13.5625 4 13.125 4H9.03125C8.3125 4 7.71875 4.5625 7.625 5.1875L6 11.8125C5.9375 12.25 6.0625 12.6562 6.34375 13C6.625 13.3125 7.0625 13.5 7.5 13.5H10.5625L9.46875 18.25C9.375 18.6875 9.46875 19.125 9.71875 19.4688C10 19.8125 10.4062 20 10.8438 20C11.375 20 11.8438 19.75 12.0625 19.3438L17.7812 10.6875C18.0625 10.25 18.0625 9.71875 17.7812 9.25ZM11 18.3125L12.4375 12H7.46875L9.03125 5.5H13.0312L11.5312 10.0312H16.4375L11 18.3125Z",
  fill: "#191B1C"
}));

var SvgIcnPower = function SvgIcnPower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-power.25e0393c.svg";
export { ForwardRef as ReactComponent };